import {CreateCoverNote, Identity, InsurerId, SortBy, UpdateDocument, VoidDocument} from '../../Config/dataModel';
import {
    fetchAllArchived,
    fetchAllCoverNotes,
    fetchArchivedCount,
    fetchCoverNote,
    fetchCoverNoteCount,
    fetchCoverNoteHistory,
    insurerApplyCN,
    insurerConfirmCN,
    subAgentApplyCN,
    updateCoverNote,
    voidCoverNote
} from '../Actions/coverNoteAction';

export default (dispatch) => {
    return {
        fetchAllCoverNotes: (data: SortBy) => {
            dispatch(fetchAllCoverNotes(data));
        },
        fetchAllArchived: (data: SortBy) => {
            dispatch(fetchAllArchived(data));
        },
        fetchCoverNote: (ref: string, data: InsurerId) => {
            dispatch(fetchCoverNote(ref, data));
        },
        fetchCoverNoteCount: (data: InsurerId) => {
            dispatch(fetchCoverNoteCount(data));
        },
        fetchArchivedCount: (data: InsurerId) => {
            dispatch(fetchArchivedCount(data));
        },
        subAgentApplyCN: (data: CreateCoverNote) => {
            dispatch(subAgentApplyCN(data));
        },
        insurerApplyCN: (data: CreateCoverNote) => {
            dispatch(insurerApplyCN(data));
        },
        insurerConfirmCN: (ref: string, data: Identity) => {
            dispatch(insurerConfirmCN(ref, data));
        },
        updateCoverNote: (ref: string, data: UpdateDocument) => {
            dispatch(updateCoverNote(ref, data));
        },
        voidCoverNote: (ref: string, data: VoidDocument) => {
            dispatch(voidCoverNote(ref, data));
        },
        fetchCoverNoteHistory: (ref: string, data: InsurerId) => {
            dispatch(fetchCoverNoteHistory(ref, data));
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/coverNoteDispatch.ts